import FileCardComponent from './FileCardComponent';
export default FileCardComponent;
